import { toast as sonnerToast } from 'sonner';

export const toast = {
  success: (message) => sonnerToast.success(message, { duration: 2800 }),
  error: (message) => sonnerToast.error(message, { duration: 2800 }),
  info: (message) => sonnerToast.info(message, { duration: 2800 }),
  loading: (message) => sonnerToast.loading(message)
};
